import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { requireAuth } from "@/lib/auth";
import { AppLayout, PageTransition, useHeaderConfig } from "@/components/layout";
import { ClubsList, CreateClubForm } from "@/components/clubs";
import { useAuth } from "@/components/providers/AuthProvider";
import { Button } from "@/components/ui/Button";

export const Route = createFileRoute("/clubs/")({
  beforeLoad: requireAuth,
  component: ClubsPage,
});

function ClubsPage() {
  const { user } = useAuth();
  const [createClubOpen, setCreateClubOpen] = useState(false);

  // Set header configuration for this page
  useHeaderConfig(
    {
      breadcrumbs: [{ label: "All clubs" }],
      actions: user?.id ? (
        <Button
          onClick={() => setCreateClubOpen(true)}
          variant="olive"
          size="pill-sm"
        >
          Start a club
        </Button>
      ) : null,
    },
    [user?.id]
  );

  return (
    <AppLayout>
      <PageTransition>
        {/* Content - offset for floating sidebar on desktop */}
        <div className="p-6 lg:pl-24">
          <div className="max-w-[1400px] mx-auto">
            <ClubsList />
          </div>
        </div>
      </PageTransition>

      {/* Create Club Form */}
      {user?.id && (
        <CreateClubForm
          creatorId={user.id}
          open={createClubOpen}
          onOpenChange={setCreateClubOpen}
        />
      )}
    </AppLayout>
  );
}
